// AutocompleteInput.js
import React from "react";
import Autocomplete from "react-google-autocomplete";

const AutocompleteInput = ({
  onPlaceSelected,
  name,
  value,
  options = {},
  ...rest
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "start",
      }}
    >
      <Autocomplete
        apiKey={process.env.REACT_APP_GOOGLE_MAP_KEY}
        onPlaceSelected={(place) => onPlaceSelected(place, name)}
        options={{
          ...options,
          types: ["geocode", "establishment"],
          componentRestrictions: { country: "in" },
        }}
        value={value}
        {...rest}
        inputprops={{ name, value }}
      />
      <svg
        width="16"
        height="19"
        viewBox="0 0 16 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ marginLeft: "-30px" }}
      >
        <path
          d="M14.9091 7.95455C14.9091 13.3636 7.95455 18 7.95455 18C7.95455 18 1 13.3636 1 7.95455C1 6.11009 1.73271 4.34117 3.03694 3.03694C4.34117 1.73271 6.11009 1 7.95455 1C9.79901 1 11.5679 1.73271 12.8722 3.03694C14.1764 4.34117 14.9091 6.11009 14.9091 7.95455Z"
          stroke="#9CA7AC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.9549 10.2726C9.2352 10.2726 10.2731 9.23471 10.2731 7.95441C10.2731 6.67412 9.2352 5.63623 7.9549 5.63623C6.6746 5.63623 5.63672 6.67412 5.63672 7.95441C5.63672 9.23471 6.6746 10.2726 7.9549 10.2726Z"
          stroke="#9CA7AC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default AutocompleteInput;